import { Badge } from "@/components/ui/badge"

export default function StudyChangeViewStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Vista diaria o semanal</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/study-change-view.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        Elegí cómo querés organizarte: por día o por semana.La vista diaria te ayuda a estudiar con
        el método Time Boxing, que divide tu tiempo en bloques para que te enfoques en una tarea a
        la vez y aproveches mejor tu estudio. ¡Probalo!
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 7 de 8</span>
      </Badge>
    </section>
  )
}
